import React, { useState } from 'react';

export default function HdrBeforeAfter({
  beforeUrl,
  afterUrl,
}: {
  beforeUrl: string;
  afterUrl: string;
}) {
  const [pos, setPos] = useState(50);

  return (
    <div className="relative mx-auto w-full max-w-5xl overflow-hidden rounded-2xl bg-slate-900">
      <img src={afterUrl} alt="Processed HDR image" className="block w-full" />
      <div
        className="absolute inset-0"
        style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
      >
        <img src={beforeUrl} alt="Original exposure" className="h-full w-full object-cover" />
      </div>
      <input
        type="range"
        min={0}
        max={100}
        value={pos}
        aria-label="Compare before and after"
        onChange={(e) => setPos(Number(e.target.value))}
        className="absolute inset-x-0 bottom-4 z-10 mx-auto w-2/3 accent-white"
      />
    </div>
  );
}
